import D3BarAndPieChart from './d3BarAndPieChart'
export default D3BarAndPieChart
